import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { StorageService } from '../../../../core/storage/storageService';
import { User } from '../../../../models/users/user';
import { UserService } from '../../../../models/users/userService';
import { UIErrorHandler } from '../../../../core/uiErrorHandler';
import { UIHelpers } from '../../../../core/ui-helpers';

@Component({
  selector: 'app-impersonate-header',
  templateUrl: './impersonate-header.component.html',
  standalone: false,
})
export class ImpersonateHeaderComponent implements OnDestroy {
  impersonatedUser: User | undefined = undefined;
  currentUserObserver: Subscription | undefined = undefined;

  constructor(
    public storage: StorageService,
    private userService: UserService,
    private router: Router,
    private uiErrorHandler: UIErrorHandler,
    private UIHelpers: UIHelpers
  ) {
    this.detectImpersonationInProgress();

    userService.isImpersonating$.subscribe((newbool: boolean | undefined) => {
      if (newbool) {
        this.impersonatedUser = this.storage.getCurrentUser();
        //this.router.navigateByUrl("merchants/profile");
        this.router.navigateByUrl('dashboard');
      } else {
        this.impersonatedUser = undefined;
      }
    });
  }

  ngOnInit() {
    this.currentUserObserver = this.storage.currentUserObservable.subscribe(
      (data) => {
        if (data && this.impersonatedUser) {
          this.impersonatedUser = data;
        } else {
          this.impersonatedUser = undefined;
        }
      },
    );
  }

  ngOnDestroy(): void {
    this.currentUserObserver?.unsubscribe();
  }

  getUserRoleToDisplay() {
    return this.UIHelpers.toTitleCase(this.impersonatedUser?.originalRole?.replace("portal.", "") ?? "");
  }

  detectImpersonationInProgress() {
    if (this.storage.getImpersonatingUser() != null) {
      this.impersonatedUser = this.storage.getCurrentUser();
      this.UIHelpers.toTitleCase(this.impersonatedUser.originalRole?.replace("portal.", "") ?? "");
    } else {
      this.impersonatedUser = undefined;
    }
  }

  async btnEndImpersonation_click() {
    let impersonateId = this.storage.getCurrentUser()?.id;
    this.userService
      .endUserImpersonation()
      .then(() => {
        let url = this.storage.getNextRedirectUrlAndClear();

        if (url) {
          this.router.navigateByUrl(url);
        } else {
          this.router.navigateByUrl('reroute?route=user?id=' + impersonateId);
        }
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }
}
